/* eslint-disable no-restricted-globals */
import React, { useState } from "react";

import { IoChevronDown } from "react-icons/io5";

import AppButton from "../../common/AppButton";
import LabelText from "../../common/LabelText";
import moment from "moment";
import useTasks from "../../hooks/useTasks";
import api from "../../config/api";
import { Menu } from "primereact/menu";
import EditMultipleTaskAssignModel from "../../components/EditMultipleTaskAssignModel";
import findDates from "../../utility/findDates";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

export default function MarkTaskModel() {
  const queryClient = useQueryClient();

  const Body = ({ task }) => {
    const tsk = useTasks();

    const startTime = moment(task.startTime, "hh:mma");
    const endTime = moment(task.endTime, "hh:mma");
    var duration = moment.duration(endTime.diff(startTime));
    duration = `${duration.get("hours")} h ${duration.get("minutes")} m`;

    return (
      <div
        className="d-flex"
        style={{ padding: "10px 30px", flexDirection: "column", gap: 20 }}
      >
        <div className="d-flex" style={{ flexGrow: 1 }}>
          <LabelText
            label="Date"
            columnMode
            value={moment(task.date).format("dddd, DD/MM/YYYY")}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />

          <LabelText
            label="Status"
            columnMode
            value={tsk.taskStatus({ task })}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />
        </div>

        <div className="d-flex" style={{ flexGrow: 1 }}>
          <LabelText
            label="From"
            columnMode
            value={task.startTime}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />

          <LabelText
            label="To"
            columnMode
            value={task.endTime}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />
        </div>

        <div className="d-flex" style={{ flexGrow: 1 }}>
          <LabelText
            label="Assignee"
            columnMode
            value={
              Array.isArray(task.employee)
                ? task.employee.map((i) => i?.name || "N/A").join(", ")
                : task.employee?.name || "N/A"
            }
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />
          <LabelText
            label="Duration"
            columnMode
            value={duration}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />
        </div>

        <div className="d-flex" style={{ flexGrow: 1 }}>
          <LabelText
            label="Organization"
            columnMode
            value={task.organization?.name || "N/A"}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          />

          {/* <LabelText
            label="Job Location"
            columnMode
            value={task.job?.location.title || task.contract?.location.title}
            style={{
              borderBottom: "1px solid #77777720",
              paddingBottom: 5,
              paddingLeft: 10,
              width: "100%",
            }}
          /> */}
        </div>

        {(task.autoClockOutReason || task.expiredAt) && (
          <div
            className="d-flex"
            style={{
              flexGrow: 1,
              backgroundColor: "#fff8f8",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ff000020",
            }}
          >
            {task.autoClockOutReason && (
              <LabelText
                label="Auto Clock-Out Reason"
                columnMode
                value={task.autoClockOutReason}
                style={{ width: "100%" }}
              />
            )}
            {task.autoClockOutAt && (
              <LabelText
                label="Auto Clock-Out At"
                columnMode
                value={moment(task.autoClockOutAt).format("hh:mm a")}
                style={{ width: "100%" }}
              />
            )}
            {task.expiredAt && (
              <LabelText
                label="Expired At"
                columnMode
                value={moment(task.expiredAt).format("hh:mm a")}
                style={{ width: "100%" }}
              />
            )}
          </div>
        )}
      </div>
    );
  };
  const Header = ({ task, onDone, setModel }) => {
    const tsk = useTasks();
    const updateStatus = async (event) => {
      const status = event.item.label;
      const res = await api.put("tasks", {
        _id: task._id,
        status,
      });
      if (!res.ok) {
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["tasks"]);

      toast.success("Task has been succesfully marked completed.");

      onDone && onDone();
    };

    const handleRemove = async (event) => {
      if (confirm("Are you sure want to delete the tasks ?") === false)
        return false;
      const res = await api.put("tasks", {
        _id: task._id,
        isDeleted: true,
      });
      if (!res.ok) {
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["tasks"]);

      toast.success("Task has been succesfully marked completed.");
      onDone && onDone();
    };

    const MultiSchedule = EditMultipleTaskAssignModel();
    const handleWeeklyEdit = () => {
      const dates = findDates({ from: task.date, days: 7 }).map((i) => ({
        date: i,
      }));

      const random = Math.random();
      setModel({
        body: (
          <MultiSchedule.Body
            dates={dates}
            task={task}
            onDone={() => {
              onDone && onDone();
            }}
          />
        ),
        header: <MultiSchedule.Header />,
        footer: <MultiSchedule.Footer random={random} />,
        visible: true,
      });
    };

    const actions = [
      {
        label: "Scheduled",
        style: {
          color: "red",
        },
        icon: "pi pi-clock",
        command: updateStatus,
      },
      {
        label: "Done",
        icon: "pi pi-check",
        command: updateStatus,
      },
      {
        label: "InProgress",
        icon: "pi pi-spinner",
        command: updateStatus,
      },
      {
        label: "Not Completed",
        icon: "pi pi-times",
        command: updateStatus,
      },
      {
        label: "Edit",
        icon: "pi pi-cog",
        color: "tomato",
        command: handleWeeklyEdit,
      },
      {
        label: "Remove",
        icon: "pi pi-trash",
        color: "tomato",
        command: handleRemove,
      },
    ];
    const [showMenu, setShowMenu] = useState(false);
    const sts = tsk.taskStatus({ task });

    return (
      <div
        className="d-flex"
        style={{ justifyContent: "space-between", flexGrow: 1 }}
      >
        <span className="d-flex" style={{ alignItems: "center" }}>
          <b>Tasks details </b>
        </span>

        <div>
          <AppButton
            text={tsk.taskStatus({ task })}
            onClick={(event) => {
              setShowMenu(!showMenu);
            }}
            style={{
              color:
                sts === ("Done" || "Completed")
                  ? "#4BB543"
                  : sts === "Not Completed"
                  ? "tomato"
                  : "dodgerblue",
            }}
            leftIcon={<IoChevronDown size={22} />}
          />
          <Menu
            model={actions}
            style={{
              zIndex: 1000000,
              position: "absolute",
              right: 17,
              display: showMenu ? "block" : "none",
            }}
          />
        </div>
      </div>
    );
  };
  const Footer = ({ task, onDone }) => {
    const tsk = useTasks();

    const [disabled, setDisabled] = useState(false);
    const markCompleted = async () => {
      setDisabled(true);
      const res = await api.put("tasks", {
        _id: task._id,
        status: "Completed",
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["tasks"]);

      toast.success("Task has been succesfully marked completed.");
      setDisabled(false);
      onDone && onDone();
    };
    if (tsk.taskStatus({ task }) === "Completed") return false;

    return (
      <AppButton
        disabled={disabled}
        text="Mark Completed"
        onClick={markCompleted}
        className="text-success btn-light"
      />
    );
  };

  return { Body, Header, Footer };
}
